var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-hover table-sm"},[_c('thead',[_c('TableHead')],1),_c('tbody',_vm._l((_vm._products),function(product){return _c('Product',{key:product.id,attrs:{"product":product,"pagaName":_vm.pagaName}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }